<template>
  <v-app color="primary">
    <v-fade-transition>
      <v-sheet
        tile
        class="fill-height loading-overlay"
        color="primary"
        align="center"
        v-show="!isInitialized || forcedLoad"
      >
        <v-container fluid class="fill-height">
          <v-card-text>
            <br />
            <v-img src="/static/logo.png" class="main-logo"></v-img>
            <br />
            <v-progress-circular
              color="white"
              indeterminate
            ></v-progress-circular>
            <br />
            <br />
            <v-sheet tile color="primary" dark>Loading...</v-sheet>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </v-card-text>
        </v-container>
      </v-sheet>
    </v-fade-transition>
    <template>
      <v-app-bar
        app
        v-if="$route.meta.page_title_needed"
        color="primary"
        dense
        flat
        dark
      >
        <v-btn
          class="back-btn"
          icon
          color="white"
          @click="goBack()"
          v-if="goBackAvailable"
        >
          <v-icon>navigate_before</v-icon>
        </v-btn>
        <router-link :to="getDefaultPage">
          <v-img src="/static/logo.svg" class="main-logo"></v-img>
        </router-link>
        <v-progress-linear
          absolute
          bottom
          color="white"
          :active="loadingState"
          :indeterminate="loadingState"
        ></v-progress-linear>
      </v-app-bar>

      <v-snackbar
        class="mt-12"
        vertical
        :timeout="600000"
        top
        color="white"
        :value="snackbar"
      >
        <v-list-item dense>
          <v-list-item-content>
            <v-list-item-title class="primary--text"
              >New Version is Available!</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>

        <v-list-item dense v-for="feature in features" :key="feature.title">
          <v-list-item-icon class="mx-0">
            <v-icon color="success">check_circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ feature.title }}</v-list-item-title>
            <v-list-item-subtitle>{{ feature.subtitle }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-btn
          class="mx-0 my-2 text-capitalize"
          block
          depressed
          color="primary"
          @click="handleUpdate"
          >Update to latest Version
        </v-btn>
      </v-snackbar>
      <v-content>
        <v-slide-x-transition name="fade" mode="out-in">
          <router-view />
        </v-slide-x-transition>
      </v-content>
      <bottom-navigation v-if="userIsAuthenticated"></bottom-navigation>
      <add-user-modal></add-user-modal>
      <div class="error-bar" v-if="error_message">
        {{ error_message }}
      </div>
    </template>
  </v-app>
</template>

<script>
import * as CodeMirror from 'codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/dracula.css';
import 'codemirror/mode/javascript/javascript.js';
import 'codemirror/mode/gfm/gfm.js';

import { BottomNavigation } from "./Navigation";
import AddUserModal from "./Users/AddUserModal";
import { mapGetters, mapActions } from "vuex";
import DashboardStoreSearch from "./Elements/DashboardStoreSearch";
import { Auth } from "aws-amplify";
import {registerUserForNotification} from "@/utils/utils"
export default {
  data: () => ({
    features: []
  }),
  metaInfo: {
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
      }
    ]
  },
  name: "app",
  components: { DashboardStoreSearch, AddUserModal, BottomNavigation },

  computed: {
    ...mapGetters([
      "loadingState",
      "drawerState",
      "userIsAuthenticated",
      "getDefaultPage",
      "isInitialized",
      "forcedLoad",
      "error_message"
    ]),
    allowAction() {
      let routes_with_actions = [
        "brand_add",
        "brand_edit",
        "store_add",
        "store_edit"
      ];
      return routes_with_actions.includes(this.$route.name);
    },
    snackbar() {
      // return this.$parent._data.snackbar;

      return false;
    },
    drawerWidth() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 300;
      } else {
        return 360;
      }
    },
    drawer: {
      get() {
        return this.$store.state.drawer_state;
      },
      set(val) {
        this.$store.commit("TOGGLE_DRAWER", val);
      }
    },
    allowDrawer() {
      return this.$route.meta.drawer_needed;
    },
    goBackAvailable() {
      return (
        this.$route.meta.parent !== undefined &&
        this.$route.meta.parent(this.$route, this.$store) !== undefined
      );
    }
  },

  methods: {
    handleUpdate() {
      let reload_btn = document.getElementById("reload");
      reload_btn.click();
    },
    goBack() {
      this.$router.push(this.$route.meta.parent(this.$route, this.$store));
    },

    // registerUserForNotification() {
    //   Auth.currentSession()
    //     .then(data => {
    //       this.$store.dispatch("setOwnerId", data.idToken.payload.sub);
    //     })
    //     .catch(err => console.log(err));

    //   try {
    //     var ownerId = this.$store.getters.currentOwnerId;
    //     console.log("owner id : ", ownerId);
    //     if (ownerId !== "null" && ownerId !== "") {
    //       OneSignal.push(function() {
    //         OneSignal.setExternalUserId(ownerId);
    //       });
    //     }
    //   } catch (error) {}
    // }
  },

  mounted() {
    registerUserForNotification();
  }
};
</script>
<style lang="scss">
@import "scss/main";
</style>



// WEBPACK FOOTER //
// src/App.vue